import * as React from "react"
import { observer } from "mobx-react"
import { text as legalText } from "./lava-island-waiver-text"
import { WaiverEditor } from "./WaiverEditor"
import SignatureCanvas from "react-signature-canvas"
@observer
export class WaiverField extends React.Component<{
  label: string
  text?: string
  textLines?: string[]
}> {
  render() {
    const { label, text, textLines } = this.props

    const printText = (theText: string, i: number) => (
      <div
        key={i}
        className="has-text-weight-italic"
        style={{ fontFamily: "Courier" }}
      >
        {theText}
      </div>
    )
    return (
      <div
        style={{ marginBottom: 10, display: "flex", flexDirection: "column" }}
      >
        <div className="has-text-weight-bold">{label}</div>
        {textLines && textLines.length
          ? textLines.map((t, i) => {
              return printText(t, i)
            })
          : text
            ? printText(text, 0)
            : ""}
      </div>
    )
  }
}

@observer
export class SignWaiver extends React.Component<{
  model: WaiverEditor
}> {
  render() {
    const { model } = this.props

    const { waiver, adult, minorsOnWaiver } = model
    const minors = minorsOnWaiver

    if (!adult) {
      return (
        <div>
          <div style={{ flex: "1", width: "100%", flexDirection: "column" }}>
            Cannot sign waiver unless it has one adult
          </div>
        </div>
      )
    }
    return (
      <div
        style={{
          flex: "1",
          width: "100%",
          flexDirection: "column",
          fontFamily: "sans-serif"
        }}
      >
        <div
          style={{ width: "100%", flexDirection: "column", marginBottom: 20 }}
        >
          <WaiverField
            label="Name"
            text={adult.object.firstName + " " + adult.object.lastName}
          />
          <WaiverField label="DOB" text={adult.dobFriendlyString} />
          <WaiverField label="Email" text={adult.object.email} />
          <WaiverField
            label="Address"
            textLines={[
              adult.object.street as string,
              ((adult.object.city as string) +
                ", " +
                adult.object.zip) as string,
              adult.object.state as string
            ]}
          />
          {minors &&
            minors.length > 0 && (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <WaiverField label="Minors" text="" />
                <table className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth">
                  <thead>
                    <tr>
                      <td>Name</td>
                      <td>DOB</td>
                    </tr>
                  </thead>
                  <tbody>
                    {minors.map((m, i) => (
                      <tr key={i}>
                        <td>{m.object.firstName + " " + m.object.lastName}</td>
                        <td>
                          {m.object.dobMonth +
                            " " +
                            m.object.dobDay +
                            " " +
                            m.object.dobYear}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
        </div>
        <div dangerouslySetInnerHTML={{ __html: legalText }} />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "2%",
            flexDirection: "column"
          }}
        >
          <div
            style={{
              boxShadow:
                "0 10px 20px rgba(0,0,0,0.19), 2px 2px 7px 3px rgba(0,0,0,0.23)"
            }}
          >
            <SignatureCanvas
              canvasProps={{
                width:
                  window.innerWidth > 450
                    ? window.innerWidth * 0.75
                    : window.innerWidth * 0.9,
                height: window.innerHeight * 0.2,
                className: "sigCanvas"
              }}
              ref={(ref: any) => {
                model.sigPad = ref
              }}
            />
          </div>
          <button
            style={{
              marginTop: "1.5%",
              display: waiver.isSigned ? "none" : "block",
              width: window.innerWidth * 0.75
            }}
            className="button is-fullwidth"
            onClick={model.clear}
          >
            Clear
          </button>
        </div>
      </div>
    )
  }
}
